<template>
  <div :class="classnames">
    <div>Share link is expired.</div>
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'page-share-link-expired'

  export default {
    name: 'ShareLinkExpired',
    components: {},
    mixins: [ bem ],
    data: function () {
      return {}
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
  $ns: '.page-share-link-expired';

  #{$ns} {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/js/pages/ShareLinkExpired.vue